import { createSlice } from '@reduxjs/toolkit';
import { getComplains, getTodaysVisits, getFrequencies, getDurations, getSeverities, getDiagnosis, getMedicine, getDose, getTiming, getTestRequired, getAdvice, getDietExercises, getPastVisits, getGeneral, getCvs, getRs, getCns, getPa, getEnt, getAllVisits, createVisit, getVisitById, getTestDeadline } from '.';

const initialState = {
	success: false,
	error: '',
	loading: false,
	complains: [],
	todaysVisits: [],
	pastVisits: [],
	totalTodaysVisits: 0,
	totalPastVisits: 0,
	allVisits: [],
	totalAllVisits: 0,
	todaysVisitsError: '',
	frequencies: [],
	durations: [],
	testDeadline: [],
	severities: [],
	diagnosis: [],
	medicines: [],
	doses: [],
	timings: [],
	testRequired: [],
	advice: [],
	dietExercises: [],
	general: [],
	cvs: [],
	rs: [],
	cns: [],
	pa: [],
	ent: [],
	lastComplaintVisit: [],
	lastDiagnosisVisit: [],
	lastPrescriptionVisit: [],
	visitDetails: null,
};

const visits = createSlice({
	name: 'visit',
	initialState,
	reducers: {
		resetVisitDetails: (state) => {
			state.visitDetails = null;
		},
		resetVisit: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(getComplains.pending, (state) => {
				state.loading = true;
			})
			.addCase(getComplains.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.complains = data;
			})
			.addCase(getComplains.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getTodaysVisits.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTodaysVisits.fulfilled, (state, action) => {
				state.loading = false;
				const { total, data } = action.payload.response.data.data;
				state.todaysVisits = data;
				state.totalTodaysVisits = total;
			})
			.addCase(getTodaysVisits.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getPastVisits.pending, (state) => {
				state.loading = true;
			})
			.addCase(getPastVisits.fulfilled, (state, action) => {
				state.loading = false;
				const { data, total } = action.payload.response.data.data;
				state.pastVisits = data;
				state.totalPastVisits = total;
			})
			.addCase(getPastVisits.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getAllVisits.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllVisits.fulfilled, (state, action) => {
				state.loading = false;
				const { total, data } = action.payload.response.data.data;
				state.allVisits = data;
				state.totalAllVisits = total;
			})
			.addCase(getAllVisits.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getFrequencies.pending, (state) => {
				state.loading = true;
			})
			.addCase(getFrequencies.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.frequencies = data;
			})
			.addCase(getFrequencies.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getDurations.pending, (state) => {
				state.loading = true;
			})
			.addCase(getDurations.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.durations = data;
			})
			.addCase(getDurations.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getSeverities.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSeverities.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.severities = data;
			})
			.addCase(getSeverities.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getDiagnosis.pending, (state) => {
				state.loading = true;
			})
			.addCase(getDiagnosis.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.diagnosis = data;
			})
			.addCase(getDiagnosis.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getTestDeadline.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTestDeadline.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.testDeadline = data;
			})
			.addCase(getTestDeadline.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getMedicine.pending, (state) => {
				state.loading = true;
			})
			.addCase(getMedicine.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.medicines = data;
			})
			.addCase(getMedicine.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getDose.pending, (state) => {
				state.loading = true;
			})
			.addCase(getDose.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.doses = data;
			})
			.addCase(getDose.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getTiming.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTiming.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.timings = data;
			});

		builder
			.addCase(getTestRequired.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTestRequired.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.testRequired = data;
			})
			.addCase(getTestRequired.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getAdvice.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAdvice.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.advice = data;
			})
			.addCase(getAdvice.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getDietExercises.pending, (state) => {
				state.loading = true;
			})
			.addCase(getDietExercises.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.dietExercises = data;
			})
			.addCase(getDietExercises.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getGeneral.pending, (state) => {
				state.loading = true;
			})
			.addCase(getGeneral.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.general = data;
			})
			.addCase(getGeneral.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getCvs.pending, (state) => {
				state.loading = true;
			})
			.addCase(getCvs.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.cvs = data;
			})
			.addCase(getCvs.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getCns.pending, (state) => {
				state.loading = true;
			})
			.addCase(getCns.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.cns = data;
			})
			.addCase(getCns.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getPa.pending, (state) => {
				state.loading = true;
			})
			.addCase(getPa.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.pa = data;
			})
			.addCase(getPa.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getEnt.pending, (state) => {
				state.loading = true;
			})
			.addCase(getEnt.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.ent = data;
			})
			.addCase(getEnt.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getRs.pending, (state) => {
				state.loading = true;
			})
			.addCase(getRs.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data.data;
				state.rs = data;
			})
			.addCase(getRs.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(createVisit.pending, (state) => {
				state.loading = true;
			})
			.addCase(createVisit.fulfilled, (state, action) => {
				state.loading = false;
				state.success = action.payload.response.data;
			})
			.addCase(createVisit.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload.response.data;
			});

		builder
			.addCase(getVisitById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getVisitById.fulfilled, (state, action) => {
				state.loading = false;
				const { data } = action.payload.response.data;
				state.visitDetails = data;
			})
			.addCase(getVisitById.rejected, (state) => {
				state.loading = false;
				state.visitDetails = null;
			});
	}
});

export const { resetVisitDetails, resetVisit } = visits.actions;

export default visits.reducer;